import { createApp } from 'vue'
import App from './App.vue'


import 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-editable'
import 'leaflet-path-transform'
import 'leaflet-textpath'
import 'leaflet.tilelayer.colorfilter'
    import 'leaflet.utm'
// import 'leaflet-rotate-map'
// import 'leaflet-texticon'

// import 'Lockr'


// import Vue from 'vue'
// Vue.prototype.$lockr = require('lockr');


import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import router from './router'


import "./app/styles/my-paper.css";
import "./app/styles/my-style.css";

// import jQuery from 'jquery'
// window.$ = jQuery
// window.jQuery = jQuery

createApp(App).use(router).mount('#app')
